import React, { useEffect } from "react";
import { Controller, useWatch } from "react-hook-form";
import {
  BlueBirdTheme,
  Button,
  Dropdown, Loading, Radio, RadioGroup,
  Typography,
} from "@kitbird/core";
import { FormContainer } from "./BusinessForm.styled";
import useBusiness from "../../hooks/useBusiness";

interface BusinessFormProps {
  useCustomHook: ReturnType<typeof useBusiness>;
  onClose: () => void;
}

const BusinessForm = ({ useCustomHook, onClose }: BusinessFormProps) => {
  const {
    editValue,
    methods,
    handleCodeTypeChange,
    handleAreaChange,
    handlePoolChange,
    handleCompanyChange,

    segmentOpts,
    areaOpts,
    poolOpts,
    companyOpts,
    companyRelationOpts,
    onSubmit,
    isUpdateLoading,
  } = useCustomHook;
  const {
    control, reset,
  } = methods;

  const codeType = useWatch({ control, name: "codeType" });
  const hasRelation = useWatch({ control, name: "hasRelation" });

  useEffect(() => {
    if (editValue) {
      reset({ ...editValue });
    }
  }, [editValue]);

  return (
    <form>
      <FormContainer>
        <Controller
          control={control}
          name="codeType"
          render={({
            field: {
              name, value, onChange,
            },
            fieldState: { error },
          }) => (
            <div>
              <RadioGroup
                name={name}
                value={value}
                onChange={(event) => {
                  onChange(event.target.value);
                  handleCodeTypeChange();
                }}
                title="Tipe user"
              >
                <div
                  className="radio-group"
                >
                  <Radio
                    label="HO"
                    value="O"
                    checked={value === "O"}
                  />
                  <Radio
                    label="Pool"
                    value="P"
                    checked={value === "P"}
                  />
                  <Radio
                    label="Pangkalan"
                    value="H"
                    checked={value === "H"}
                  />
                </div>
              </RadioGroup>
              <Typography
                level={7}
                color={BlueBirdTheme.colors.danger[500]}
              >{error?.message}</Typography>
            </div>
          )
          }
        />
        <div className="grid-form">
          <Controller
            control={control}
            name="area"
            render={({
              field: {
                name, onChange, ref, value,
              },
              fieldState: { error },
            }) => (
              <Dropdown
                name={name}
                id={name}
                label="Wilayah"
                options={areaOpts}
                ref={ref}
                value={value?.label || ""}
                onSelected={(opt) => {
                  onChange(opt);
                  handleAreaChange();
                }}
                error={error && { message: error.message || "" }}
                disabled={codeType === "O" || !codeType}
              />
            )}
          />
          <Controller
            control={control}
            name="pool"
            render={({
              field: {
                name, onChange, ref, value,
              },
              fieldState: { error },
            }) => (
              <Dropdown
                name={name}
                id={name}
                label={codeType === "H" ? "Pangkalan" : "Pool"}
                options={poolOpts}
                ref={ref}
                value={value?.label || ""}
                onSelected={(opt) => {
                  onChange(opt);
                  handlePoolChange();
                }}
                error={error && { message: error.message || "" }}
                disabled={codeType === "O" || !poolOpts.length}
              />
            )}
          />
          <Controller
            control={control}
            name="company"
            render={({
              field: {
                name, onChange, ref, value,
              },
              fieldState: { error },
            }) => (
              <Dropdown
                name={name}
                id={name}
                label="Perusahaan"
                options={companyOpts}
                ref={ref}
                value={value?.label || ""}
                onSelected={(arg) => {
                  onChange(arg);
                  handleCompanyChange();
                }}
                error={error && { message: error.message || "" }}
                disabled={!companyOpts.length}
              />
            )}
          />
          <Controller
            control={control}
            name="companyRelation"
            render={({
              field,
              fieldState: { error },
            }) => (
              <Dropdown
                {...field}
                id={field.name}
                label="Perusahaan relasi"
                options={companyRelationOpts}
                value={field.value?.label || ""}
                onSelected={field.onChange}
                error={error && { message: error.message || "" }}
                disabled={!hasRelation}
              />
            )}
          />
        </div>
        <Controller
          control={control}
          name="segment"
          render={({
            field: {
              name, onChange, ref, value,
            },
            fieldState: { error },
          }) => (
            <Dropdown
              name={name}
              id="segment"
              label="Segmen"
              options={segmentOpts}
              ref={ref}
              value={value?.label || ""}
              onSelected={onChange}
              error={error && { message: error.message || "" }}
              disabled={!segmentOpts.length}
            />
          )}
        />
        <div className="action-container">
          <Button
            variant="text"
            type="button"
            onClick={onClose}
            disabled={isUpdateLoading}
          >
            Batal
          </Button>
          <Button
            onClick={(e) => {
              e.preventDefault();
              onSubmit();
            }}
            leftIcon={isUpdateLoading && <Loading variant="circular" />}
            disabled={isUpdateLoading}
          >
            Simpan
          </Button>
        </div>
      </FormContainer>
    </form >
  );
};

export default BusinessForm;
